import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "section create-report" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "section__description mb-4 mt-5" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "steps" }
const _hoisted_12 = { class: "steps__line" }
const _hoisted_13 = { class: "steps__items" }
const _hoisted_14 = { class: "title steps__title" }
const _hoisted_15 = { class: "steps__text text" }
const _hoisted_16 = { class: "label label-ul" }
const _hoisted_17 = {
  key: 0,
  class: "statistic-list"
}
const _hoisted_18 = { class: "title steps__title" }
const _hoisted_19 = { class: "steps__text text" }
const _hoisted_20 = { class: "title steps__title" }
const _hoisted_21 = { class: "steps__text text" }
const _hoisted_22 = { class: "download" }
const _hoisted_23 = { class: "content" }
const _hoisted_24 = { class: "text-bold" }
const _hoisted_25 = { class: "text--primary" }
const _hoisted_26 = { class: "button download__button button--primary" }
const _hoisted_27 = { class: "expand" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Excel File ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" PDF File ")
const _hoisted_30 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_31 = { class: "modal-content modal-content__auth" }
const _hoisted_32 = { class: "modalcontent" }
const _hoisted_33 = { class: "modalcontent__h2" }
const _hoisted_34 = { class: "modalcontent__margin__auth" }
const _hoisted_35 = { class: "buttons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BreadCrumbs = _resolveComponent("BreadCrumbs")
  const _component_SectionTitle = _resolveComponent("SectionTitle")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _directive_click_outside_element = _resolveDirective("click-outside-element")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_BreadCrumbs, { links: [{ to: 'create-report', name: 'adaptiveTop.createReport' }] }),
        _createVNode(_component_SectionTitle, {
          title: _ctx.$t('pages.about.title1'),
          class: "create-report__title"
        }, null, 8, ["title"])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('app.currentPage')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", {
                class: 'line__point line__point--' + _ctx.step.isActive1
              }, [
                _createVNode(_component_svg_icon, { name: "check" })
              ], 2),
              _createVNode("div", {
                class: 'line__point line__point--' + _ctx.step.isActive2
              }, [
                _createVNode(_component_svg_icon, { name: "check" })
              ], 2),
              _createVNode("div", {
                class: 'line__point line__point--' + _ctx.step.isActive3
              }, [
                _createVNode(_component_svg_icon, { name: "check" })
              ], 2)
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", {
                class: 'steps__item steps__item--' + _ctx.step.isActive1
              }, [
                _createVNode("h1", _hoisted_14, _toDisplayString(_ctx.$t('app.stepOne')), 1),
                _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('app.insertDataToSearch')), 1),
                _withDirectives(_createVNode("div", null, [
                  _createVNode("label", _hoisted_16, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "input",
                      placeholder: _ctx.BulletinName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.data.search = $event)),
                      onKeyup: _cache[2] || (_cache[2] = (...args) => (_ctx.searchBulletinTimer(...args))),
                      onFocus: _cache[3] || (_cache[3] = (...args) => (_ctx.searchBulletinTimer(...args)))
                    }, null, 40, ["placeholder"]), [
                      [_vModelText, _ctx.data.search]
                    ]),
                    _createVNode(_component_svg_icon, { name: "magnifier" })
                  ]),
                  (_ctx.chacked)
                    ? (_openBlock(), _createBlock("ul", _hoisted_17, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletins, (bulletin) => {
                          return (_openBlock(), _createBlock("li", {
                            key: bulletin.id,
                            onClick: $event => (
                      _ctx.clickBulletinById(bulletin.id), (_ctx.chacked = !_ctx.chacked)
                      )
                          }, _toDisplayString(bulletin.name), 9, ["onClick"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_directive_click_outside_element, () => (_ctx.chacked = false)]
                ])
              ], 2),
              _createVNode("div", {
                class: 'steps__item steps__item--' + _ctx.step.isActive2
              }, [
                _createVNode("h1", _hoisted_18, _toDisplayString(_ctx.$t('app.stepTwo')), 1),
                _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('app.selectPeriod')), 1),
                _withDirectives(_createVNode("select", {
                  class: "custom-select",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.bulletinDate = $event)),
                  onChange: _cache[5] || (_cache[5] = $event => (_ctx.changePeriod()))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinPeriod, (period) => {
                    return (_openBlock(), _createBlock("option", {
                      key: period.id,
                      value: period.from_date + '=' + period.to_date
                    }, _toDisplayString(period.from_date) + " | " + _toDisplayString(period.to_date), 9, ["value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544), [
                  [_vModelSelect, _ctx.bulletinDate]
                ])
              ], 2),
              _createVNode("div", {
                class: 'steps__item steps__item--' + _ctx.step.isActive3
              }, [
                _createVNode("h1", _hoisted_20, _toDisplayString(_ctx.$t('app.stepThree')), 1),
                _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('app.downloadReport')), 1),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _createVNode("p", _hoisted_24, _toDisplayString(_ctx.BulletinName), 1),
                    _createVNode("p", _hoisted_25, _toDisplayString(_ctx.bulletinDate), 1)
                  ]),
                  _createVNode("button", _hoisted_26, [
                    _createTextVNode(_toDisplayString(_ctx.$t('app.download')) + " ", 1 /* TEXT */),
                    _createVNode(_component_svg_icon, {
                      name: "triangle-down",
                      class: "button__icon"
                    }),
                    _createVNode("div", _hoisted_27, [
                      _createVNode("div", {
                        class: "expand__item",
                        onClick: _cache[6] || (_cache[6] = $event => (_ctx.downloadFileExel()))
                      }, [
                        _createVNode(_component_svg_icon, { name: "excel-file" }),
                        _hoisted_28
                      ]),
                      _createVNode("div", {
                        class: "expand__item",
                        onClick: _cache[7] || (_cache[7] = $event => (_ctx.downloadFilePDF()))
                      }, [
                        _createVNode(_component_svg_icon, { name: "pdf-file" }),
                        _hoisted_29
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.changeactive1)
          ? (_openBlock(), _createBlock("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _createVNode("span", {
                  class: "close",
                  onClick: _cache[8] || (_cache[8] = $event => (_ctx.changeactive1 = !_ctx.changeactive1))
                }, "×"),
                _createVNode("div", _hoisted_32, [
                  _createVNode("h2", _hoisted_33, [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.authorized')) + " ", 1 /* TEXT */),
                    _createVNode("div", _hoisted_34, [
                      _createVNode("div", _hoisted_35, [
                        _createVNode("button", {
                          class: "button-using",
                          onClick: _cache[9] || (_cache[9] = $event => (_ctx.routerLink()))
                        }, _toDisplayString(_ctx.$t('profile.logIn')), 1),
                        _createVNode("button", {
                          onClick: _cache[10] || (_cache[10] = $event => (_ctx.changeactive1 = !_ctx.changeactive1)),
                          class: "button-create-new-report button-create-new-report__auth"
                        }, _toDisplayString(_ctx.$t('profile.cancel')), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}